import React from 'react';
import SectionCard from './SectionCard';
import { RadioGroup, RadioGroupItem } from '../../../components/ui/radio-group';

const WindowLocksSection = ({ submission, jsonContent, isDark }) => {
    if (submission.recipient_source === 'non-strata' || !(submission.windowLockApproval || jsonContent.windowLockApproval)) {
        return null;
    }

    return (
        <SectionCard isDark={isDark}>
            <p className={`m-0 text-[16px] font-semibold transition-colors duration-200 ${
                isDark ? 'text-white' : 'text-[#072837]'
            }`}>Was the quotes for window locks approved? <span className='text-red-500'>*</span></p>
            <RadioGroup value={submission.windowLockApproval || jsonContent.windowLockApproval}>
                <div className='flex flex-col gap-[14px]'>
                    {(submission.windowLockApproval === 'no' || jsonContent.windowLockApproval === 'no') && (
                        <div className='flex gap-[8px] items-center'>
                            <RadioGroupItem value="no" id="windowLock-no" />
                            <label htmlFor="windowLock-no" className={`text-[16px] m-0 cursor-default transition-colors duration-200 ${
                                isDark ? 'text-white' : 'text-[#072837]'
                            }`}>No</label>
                        </div>
                    )}
                    {(submission.windowLockApproval === 'yes_qsec' || jsonContent.windowLockApproval === 'yes_qsec') && (
                        <div className='flex gap-[8px] items-center'>
                            <RadioGroupItem value="yes_qsec" id="windowLock-yes_qsec" />
                            <label htmlFor="windowLock-yes_qsec" className={`text-[16px] m-0 cursor-default transition-colors duration-200 ${
                                isDark ? 'text-white' : 'text-[#072837]'
                            }`}>Yes, Qsec</label>
                        </div>
                    )}
                    {(submission.windowLockApproval === 'yes' || jsonContent.windowLockApproval === 'yes') && (
                        <div className='flex gap-[8px] items-center'>
                            <RadioGroupItem value="yes" id="windowLock-yes" />
                            <label htmlFor="windowLock-yes" className={`text-[16px] m-0 cursor-default transition-colors duration-200 ${
                                isDark ? 'text-white' : 'text-[#072837]'
                            }`}>Yes</label>
                        </div>
                    )}
                </div>
            </RadioGroup>

            {/* Contractor Name (conditional) */}
            {(submission.windowLockApproval === 'yes' || jsonContent.windowLockApproval === 'yes') && (
                <div className='flex flex-col gap-[8px]'>
                    <input 
                        className={`w-full px-[16px] py-[12px] rounded-[8px] border-none text-[16px] transition-colors duration-200 focus:outline-none focus:ring-0 focus:border-transparent ${
                            isDark 
                                ? 'bg-[#161515]  text-white' 
                                : 'bg-[#f5f5f5] text-[#072837]'
                        }`} 
                        type="text" 
                        value={submission.contractorName || jsonContent.contractorName || ''} 
                        readOnly 
                        placeholder="Contractor name" 
                    />
                </div>
            )}

            {/* Proceed With (conditional) */}
            {((submission.windowLockApproval === 'yes' || submission.windowLockApproval === 'yes_qsec') ||
                (jsonContent.windowLockApproval === 'yes' || jsonContent.windowLockApproval === 'yes_qsec')) && (
                    <div className='flex flex-col gap-[12px]'>
                        <p className={`m-0 text-[16px] font-semibold transition-colors duration-200 ${
                            isDark ? 'text-white' : 'text-[#072837]'
                        }`}>Proceed with <span className='text-red-500'>*</span></p>
                        <RadioGroup value={submission.windowLockProceedWith || jsonContent.windowLockProceedWith}>
                            <div className='flex flex-col gap-[14px]'>
                                {(submission.windowLockProceedWith === 'work_order' || jsonContent.windowLockProceedWith === 'work_order') && (
                                    <div className='flex gap-[8px] items-center'>
                                        <RadioGroupItem value="work_order" id="proceed-work_order" />
                                        <label htmlFor="proceed-work_order" className={`text-[16px] m-0 cursor-default transition-colors duration-200 ${
                                            isDark ? 'text-white' : 'text-[#072837]'
                                        }`}>Work order</label>
                                    </div>
                                )}
                                {(submission.windowLockProceedWith === 'obtain_quotes' || jsonContent.windowLockProceedWith === 'obtain_quotes') && (
                                    <div className='flex gap-[8px] items-center'>
                                        <RadioGroupItem value="obtain_quotes" id="proceed-obtain_quotes" />
                                        <label htmlFor="proceed-obtain_quotes" className={`text-[16px] m-0 cursor-default transition-colors duration-200 ${
                                            isDark ? 'text-white' : 'text-[#072837]'
                                        }`}>Obtain quotes</label>
                                    </div>
                                )}
                            </div>
                        </RadioGroup>
                    </div>
                )}

            {/* Special Requests (conditional) */}
            {((submission.windowLockApproval === 'yes' || submission.windowLockApproval === 'yes_qsec') ||
                (jsonContent.windowLockApproval === 'yes' || jsonContent.windowLockApproval === 'yes_qsec')) && 
                (submission.windowLockSpecialRequests || jsonContent.windowLockSpecialRequests) && (
                    <div className='flex flex-col gap-[8px]'>
                        <p className={`m-0 text-[16px] font-semibold transition-colors duration-200 ${
                            isDark ? 'text-white' : 'text-[#072837]'
                        }`}>Are there any special requests in respect of the window locks?</p>
                        <input 
                            className={`w-full px-[16px] py-[12px] rounded-[8px] border-none text-[16px] transition-colors duration-200 focus:outline-none focus:ring-0 focus:border-transparent ${
                                isDark 
                                    ? 'bg-[#161515]  text-white' 
                                    : 'bg-[#f5f5f5] text-[#072837]'
                            }`} 
                            type="text" 
                            value={submission.windowLockSpecialRequests || jsonContent.windowLockSpecialRequests || ''} 
                            readOnly 
                        />
                    </div>
                )}
        </SectionCard>
    );
};

export default WindowLocksSection;
